/* eslint-disable */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// @ts-ignore
import logoImage from '../tbl_logo.png';

const Why: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

    return (
        <div className="why-page standalone-page">
            <header className="main-navigation-header" style={{ position: 'relative' }}>
                <div className="header-left">
                    <a
                        href="https://www.tblservices.in/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="logo"
                        style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', position: 'relative' }}
                    >
                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                            <img src={logoImage} alt="TBL Impact Anchor" style={{ height: '45px', objectFit: 'contain' }} />
                            <span style={{
                                position: 'absolute',
                                top: '-2px',
                                right: '2px',
                                fontSize: '0.45rem',
                                color: '#000',
                                fontWeight: '900',
                                letterSpacing: '0.5px',
                                textTransform: 'uppercase',
                                pointerEvents: 'none'
                            }}>BETA</span>
                        </div>
                    </a>
                    <nav className="header-nav-tabs desktop-only">
                        <a onClick={() => navigate('/')} className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} style={{ cursor: 'pointer' }}>Home</a>
                        <a onClick={() => navigate('/why')} className={`nav-link ${location.pathname === '/why' ? 'active' : ''}`} style={{ cursor: 'pointer' }}>Why</a>
                        <a onClick={() => navigate('/what')} className={`nav-link ${location.pathname === '/what' ? 'active' : ''}`} style={{ cursor: 'pointer' }}>What</a>
                        <a onClick={() => navigate('/how')} className={`nav-link ${location.pathname === '/how' ? 'active' : ''}`} style={{ cursor: 'pointer' }}>How</a>
                    </nav>
                </div>

                <div className="header-right desktop-only">
                    <button className="btn btn-contact-us" onClick={() => navigate('/contact-us')}>
                        CONTACT US
                    </button>
                    <button className="btn btn-login-compact" onClick={() => navigate('/login')}>
                        Login
                    </button>
                </div>

                <div className="header-actions-mobile mobile-only" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <button className="btn btn-primary" onClick={() => navigate('/login')} style={{ padding: '0.4rem 1.2rem', fontSize: '0.85rem', borderRadius: '6px' }}>
                        Login
                    </button>
                    <button 
                        className="mobile-menu-btn" 
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        aria-label="Toggle mobile menu"
                        style={{ display: 'flex' }}
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            {isMobileMenuOpen ? (
                                <>
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </>
                            ) : (
                                <>
                                    <line x1="3" y1="12" x2="21" y2="12"></line>
                                    <line x1="3" y1="6" x2="21" y2="6"></line>
                                    <line x1="3" y1="18" x2="21" y2="18"></line>
                                </>
                            )}
                        </svg>
                    </button>
                </div>

                {isMobileMenuOpen && (
                    <div className="mobile-only" style={{ 
                        position: 'absolute', top: '72px', left: 0, width: '100%', 
                        background: '#ffffff', padding: '1rem', 
                        boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)', 
                        display: 'flex', flexDirection: 'column', gap: '0.5rem', zIndex: 1000 
                    }}>
                        <a onClick={() => { navigate('/'); setIsMobileMenuOpen(false); }} className={`mobile-action-btn ${location.pathname === '/' ? 'active' : ''}`} style={{ border: 'none', borderBottom: '1px solid var(--border-light)', borderRadius: 0 }}>Home</a>
                        <a onClick={() => { navigate('/why'); setIsMobileMenuOpen(false); }} className={`mobile-action-btn ${location.pathname === '/why' ? 'active' : ''}`} style={{ border: 'none', borderBottom: '1px solid var(--border-light)', borderRadius: 0 }}>Why</a>
                        <a onClick={() => { navigate('/what'); setIsMobileMenuOpen(false); }} className={`mobile-action-btn ${location.pathname === '/what' ? 'active' : ''}`} style={{ border: 'none', borderBottom: '1px solid var(--border-light)', borderRadius: 0 }}>What</a>
                        <a onClick={() => { navigate('/how'); setIsMobileMenuOpen(false); }} className={`mobile-action-btn ${location.pathname === '/how' ? 'active' : ''}`} style={{ border: 'none', borderBottom: '1px solid var(--border-light)', borderRadius: 0 }}>How</a>
                        
                        <div style={{ padding: '1rem 0 0', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            <button className="btn btn-contact-us" onClick={() => { navigate('/contact-us'); setIsMobileMenuOpen(false); }} style={{ width: '100%', padding: '0.75rem', borderRadius: 'var(--radius-sm)' }}>
                                CONTACT US
                            </button>
                        </div>
                    </div>
                )}
            </header>

            <main>
                <section className="hero-section" style={{ background: 'linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%)', padding: '6rem 2rem' }}>
                    <div style={{ maxWidth: '1000px', margin: '0 auto', textAlign: 'center' }}>
                        <h1 style={{ fontSize: '3.5rem', fontWeight: 900, marginBottom: '1.5rem', color: '#064e3b' }}>Why TBL Impact Anchor?</h1>
                        <p style={{ fontSize: '1.25rem', color: '#374151', lineHeight: 1.6, maxWidth: '800px', margin: '0 auto' }}>
                            The professional standard for impact-driven organizations. We bridge the gap between
                            strategic intent and verifiable social progress.
                        </p>
                    </div>
                </section>

                <section className="responsive-container" style={{ padding: '5rem 2rem', background: '#fff' }}>
                    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                        <div className="features-grid">
                            <div className="feature-card">
                                <div className="icon">✅</div>
                                <h3>Trusted & Transparent</h3>
                                <p>Built to connect NGOs, corporates, and partners across India for clear and accountable CSR management. Every transaction and report is verifiable.</p>
                            </div>
                            <div className="feature-card">
                                <div className="icon">🌍</div>
                                <h3>Sustainability at the Core</h3>
                                <p>Designed to maximize positive impact and track sustainability goals in real time. We help you stay aligned with ESG and CSR goals.</p>
                            </div>
                            <div className="feature-card">
                                <div className="icon">🔒</div>
                                <h3>Secure & Role-Based</h3>
                                <p>Clients and NGOs each have their own secure, real-time dashboard. Data privacy is our top priority, ensuring stakeholders see only what they need.</p>
                            </div>
                            <div className="feature-card">
                                <div className="icon">⚡</div>
                                <h3>Instant Insights</h3>
                                <p>Get analytics, compliance, and progress updates instantly—no waiting, no confusion. Automated reports save you weeks of administrative work.</p>
                            </div>
                        </div>

                        <div className="responsive-container" style={{ marginTop: '5rem', backgroundColor: '#f9fafb', borderRadius: '24px', padding: '4rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))', gap: '4rem', alignItems: 'center' }}>
                            <div>
                                <h2 style={{ fontSize: '2.5rem', color: '#111827', marginBottom: '1.5rem' }}>Our Purpose: Crafting Legacies</h2>
                                <p style={{ fontSize: '1.1rem', color: '#4b5563', lineHeight: 1.7, marginBottom: '2rem' }}>
                                    "Philanthropy is not about money. It's about using whatever resources you have at your fingertips and applying them to improving the world."
                                    <br /><strong>— Melinda Gates</strong>
                                </p>
                                <p style={{ fontSize: '1.1rem', color: '#4b5563', lineHeight: 1.7 }}>
                                    TBL Impact Anchor was born from the belief that impact shouldn't be a black box.
                                    We provide the tools to make every rupee account for real, verifiable change in the communities you serve.
                                </p>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: '5rem', marginBottom: '1rem' }}>🏗️</div>
                                <h3 style={{ fontSize: '1.5rem', fontWeight: 700 }}>Legacy Building</h3>
                                <p style={{ color: '#6b7280' }}>Building sustainable systems that outlast projects.</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="cta-section">
                    <h2>Ready to start your legacy?</h2>
                    <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center' }}>
                        <button className="btn btn-primary" onClick={() => navigate('/login')}>Get Started</button>
                        <button className="btn btn-outline-white" onClick={() => navigate('/contact-us')}>Talk to us</button>
                    </div>
                </section>
            </main>

            <footer className="main-footer">
                <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className="footer-left" style={{ textAlign: 'left' }}>
                        <img src={logoImage} alt="TBL Impact Anchor" style={{ height: '40px', objectFit: 'contain', marginBottom: '0.5rem', filter: 'brightness(0) invert(1)' }} />
                        <p style={{ fontSize: '0.8rem', opacity: 0.6 }}>Â© 2026 TBL Services. Crafted for real social impact.</p>
                    </div>
                    <div className="footer-right">
                        <div className="social-links" style={{ display: 'flex', gap: '1.25rem' }}>
                            <a href="https://www.linkedin.com/company/tblconsultancy/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
                            </a>
                            <a href="https://www.facebook.com/tblconsultancy/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
                            </a>
                            <a href="https://www.instagram.com/tbl_consultancy_services" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                            </a>
                            <a href="https://www.youtube.com/@tblservices" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33 2.78 2.78 0 0 0 1.94 2C5.12 20 12 20 12 20s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.33 2.78 2.78 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.45 11.75 9.75 8.48 9.75 15.02"></polygon></svg>
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Why;

